import { useAppDispatch, useAppSelector } from 'store/hooks';
import { closeModal, selectActiveModalData } from 'features/modal/modalSlice';
import { useTranslation } from 'react-i18next';
import { muteRemoteVideo } from 'features/streaming/actions';
import { UserId } from 'features/users/types';
import { selectActiveUserById } from 'features/users/usersSlice';
import { usePermissions } from 'features/permissions/usePermissions';
import { PermissionTypes } from 'features/permissions/types';
import { useEffect } from 'react';
import ConfirmationDialog from 'components/ConfirmationDialog';

const MuteRemoteVideoConfirmation = () => {
  const { t } = useTranslation('modals');
  const dispatch = useAppDispatch();

  const modalData = useAppSelector(selectActiveModalData);

  const userId = modalData.userId as UserId;
  const user = useAppSelector((state) => selectActiveUserById(state, userId));

  const { hasPermissions } = usePermissions();

  const canRemotelyMute = hasPermissions(PermissionTypes.remoteMuting, {
    targetRole: user?.role,
  });

  useEffect(() => {
    if (!user || !canRemotelyMute) {
      dispatch(closeModal('muteRemoteVideoConfirmation'));
    }
  }, [user, canRemotelyMute, dispatch]);

  if (!user) {
    return null;
  }

  const handleOk = () => {
    dispatch(muteRemoteVideo(user.id));
    dispatch(closeModal('muteRemoteVideoConfirmation'));
  };

  const handleCancel = () => {
    dispatch(closeModal('muteRemoteVideoConfirmation'));
  };

  return (
    <ConfirmationDialog
      open
      title={t('mute_remote_video_confirm.title', { username: user.name })}
      description={t('mute_remote_video_confirm.description', { username: user.name })}
      cancelText={t('mute_remote_video_confirm.btn_cancel_label')}
      okText={t('mute_remote_video_confirm.btn_ok_label')}
      onOk={handleOk}
      onCancel={handleCancel}
      hideCloseButton
      preventClose
    />
  );
};

export default MuteRemoteVideoConfirmation;
